import * as types from "./types";

const mutations = {
    [types.LOADING_LEAVEBALANCE](state, value) {
        state.loading = value;
    },
    [types.GET_LEAVEBALANCE_EMPLOYEE](state, employee) {
        state.employee = employee;
    },
    [types.GET_LEAVEBALANCE_SUBORDINATES](state, subordinate) {
        state.subordinate = subordinate;
    }
};

export default mutations;